define.alias("shared/utils/is-async-relation", "settings/utils/is-async-relation");